import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInstagram = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1064_78458)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z",
				fill: "url(#paint0_radial_1064_78458)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z",
				fill: "url(#paint1_radial_1064_78458)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.00056 1.75C6.30319 1.75 6.09012 1.75744 5.4235 1.78775C4.75812 1.81825 4.30394 1.92356 3.90656 2.07812C3.49544 2.23775 3.14675 2.45131 2.79937 2.79881C2.45169 3.14625 2.23812 3.49494 2.078 3.90587C1.923 4.30337 1.81756 4.75775 1.78762 5.42281C1.75781 6.0895 1.75 6.30263 1.75 8.00006C1.75 9.6975 1.7575 9.90987 1.78775 10.5765C1.81837 11.2419 1.92369 11.6961 2.07812 12.0934C2.23787 12.5046 2.45144 12.8532 2.79894 13.2006C3.14625 13.5483 3.49494 13.7624 3.90575 13.922C4.30344 14.0766 4.75769 14.1819 5.42294 14.2124C6.08962 14.2427 6.3025 14.2501 7.99981 14.2501C9.69737 14.2501 9.90975 14.2427 10.5764 14.2124C11.2417 14.1819 11.6964 14.0766 12.0941 13.922C12.5051 13.7624 12.8532 13.5483 13.2005 13.2006C13.5482 12.8532 13.7617 12.5046 13.9219 12.0936C14.0755 11.6961 14.181 11.2417 14.2122 10.5766C14.2422 9.91 14.25 9.6975 14.25 8.00006C14.25 6.30263 14.2422 6.08962 14.2122 5.42294C14.181 4.75756 14.0755 4.30344 13.9219 3.90606C13.7617 3.49494 13.5482 3.14625 13.2005 2.79881C12.8529 2.45119 12.5052 2.23762 12.0937 2.07819C11.6953 1.92356 11.2409 1.81819 10.5755 1.78775C9.90881 1.75744 9.69656 1.75 7.99862 1.75H8.00056ZM7.43988 2.87631C7.60631 2.87606 7.792 2.87631 8.00056 2.87631C9.66937 2.87631 9.86712 2.88231 10.5261 2.91225C11.1355 2.94012 11.4662 3.04194 11.6866 3.1275C11.9782 3.24075 12.1862 3.37619 12.4048 3.595C12.6236 3.81375 12.7589 4.02206 12.8725 4.31375C12.9581 4.53375 13.06 4.8645 13.0877 5.47387C13.1177 6.13275 13.1242 6.33062 13.1242 7.99862C13.1242 9.66662 13.1177 9.86456 13.0877 10.5234C13.0599 11.1327 12.9581 11.4635 12.8725 11.6836C12.7592 11.9752 12.6236 12.1829 12.4048 12.4016C12.1861 12.6203 11.9784 12.7557 11.6866 12.869C11.4665 12.9549 11.1355 13.0565 10.5261 13.0844C9.86725 13.1143 9.66937 13.1208 8.00056 13.1208C6.33169 13.1208 6.13387 13.1143 5.47506 13.0844C4.86569 13.0562 4.53494 12.9544 4.31444 12.8689C4.02281 12.7556 3.81444 12.6202 3.59569 12.4014C3.37694 12.1827 3.24156 11.9749 3.128 11.6831C3.04244 11.463 2.9405 11.1322 2.91275 10.5229C2.88281 9.864 2.87681 9.66612 2.87681 7.99706C2.87681 6.32806 2.88281 6.13119 2.91275 5.47231C2.94062 4.86294 3.04244 4.53219 3.128 4.31187C3.24131 4.02019 3.37694 3.81187 3.59575 3.59312C3.8145 3.37437 4.02281 3.23894 4.3145 3.12544C4.53481 3.0395 4.86569 2.93794 5.47506 2.90994C6.05162 2.88387 6.27506 2.87606 7.43988 2.87475V2.87631ZM11.3368 3.91406C10.9227 3.91406 10.5868 4.24969 10.5868 4.66381C10.5868 5.07788 10.9227 5.41381 11.3368 5.41381C11.7509 5.41381 12.0868 5.07788 12.0868 4.66381C12.0868 4.24975 11.7509 3.91406 11.3368 3.91406ZM8.00056 4.79037C6.22806 4.79037 4.79094 6.2275 4.79094 8.00006C4.79094 9.77262 6.22806 11.2091 8.00056 11.2091C9.77312 11.2091 11.2097 9.77262 11.2097 8.00006C11.2097 6.22756 9.77312 4.79037 8.00056 4.79037ZM8.00056 5.91669C9.15112 5.91669 10.0839 6.84938 10.0839 8.00006C10.0839 9.15063 9.15112 10.0834 8.00056 10.0834C6.84994 10.0834 5.91725 9.15063 5.91725 8.00006C5.91725 6.84938 6.84994 5.91669 8.00056 5.91669Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_1064_78458",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(4.25 17.2323) rotate(-90) scale(15.8572 14.7484)",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FFDD55" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1,
					stopColor: "#FFDD55"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#FF543E"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C837AB"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_1064_78458",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(-2.68006 1.15256) rotate(78.681) scale(7.08825 29.218)",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#3771C8" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .128,
					stopColor: "#3771C8"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6600FF",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1064_78458",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		})
	] })]
});
export default SvgInstagram;
